import $ from 'cash-dom';
import { updateCartAtribute } from '../resources/shopify-cart';
import { slideClosed } from '../utilities/animations';

const announcementBar = document.getElementById('announcement-bar') || false;

const checkAnnouncementHeight = () => {
	let height = 0;

	if (announcementBar) {
		height = announcementBar.offsetHeight || 0;
	}

	document.documentElement.style.setProperty('--announcement-height', `${height}px`);
};

$('[data-action="hide-announcement-bar"]').on('click', (e) => {
	e.preventDefault();
	slideClosed(document.getElementById('announcement-bar'));
	disableAnnouncementBar();
});

const disableAnnouncementBar = () => {
	updateCartAtribute('announcement', 'disabled');
};

const enableAnnouncementBar = () => {
	updateCartAtribute('announcement', '');
};

window.addEventListener('resize', function (e) {
	checkAnnouncementHeight();
});

document.addEventListener('DOMContentLoaded', function (event) {
	setTimeout(function () {
		checkAnnouncementHeight();
	}, 100);
});

let Luna = window.Luna || {};

Luna.enableAnnouncementBar = enableAnnouncementBar;
